import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import Theme from '../../../../Themes/ThemeArtLexie'
import Style from './Styles/FirmsStyle'
import AddFirm from './Subcomponents/AddFirm'
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

export default class FirmsComponent extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.useTheme(Theme)
        this.basicComponentConstants = {
            language: props.componentConstants.language
        }
    }

    componentDidMount() {
        super.componentDidMount()
    }

    setShowAddFirm(value) {
        this.setState({showAddFirm: value})
    }

    setShowEditFirm(value) {
        this.setState({showEditFirm: value})
    }
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('Appbar', {
            ...this.basicComponentConstants
        }).setComponentsMethods('Appbar', {
            setManagerState: (object, callback) => {
                that.props.componentMethods.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.props.componentMethods.refresh()
            },
            getManagerState: () => {
                return that.props.componentMethods.getManagerState()
            },
            changeRoute: (route) => {
                that.props.componentMethods.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.props.componentMethods.getLocalStorage(storageName)
            },
            clearErrorMessage: (index) => {
                that.props.componentMethods.clearErrorMessage(index)
            },
            ajax: (url, 
                dataObject = {}, 
                method, stateValue = '', 
                callback = () => {}, 
                headers = {}, 
                setState = true, 
                catchCallback = () => {}) => {
                    that.ajax (url, 
                        dataObject, 
                        method, stateValue, 
                        callback, 
                        headers, 
                        setState, 
                        catchCallback);
                },
            getUserFirms: () => {
                that.props.componentMethods.getUserFirms()
            },
            addError: (errorMessage, stateObject) => {
                that.props.componentMethods.addError(errorMessage, stateObject)
            },
            setShowAddFirm: (value) => {
                that.setShowAddFirm(value)
            }
        })
    }

    getRender() {
        const classes = Style();
        this.loadComponentsProps()
        return <div style={classes.root}>
                    {
                    this.state.showAddFirm ?
                        <AddFirm {...this.buildComponentProps('Appbar')} element={{}} />
                        :
                        null
                    }
                    {
                        this.props.showAddFirm && !this.state.showAddFirm ?
                        <Button style={classes.closeButton} color="primary" onClick={() => {this.setShowAddFirm(true)}} fullWidth component="div" variant="contained">
                            {this.props.componentConstants.language.LANG_ADD_FIRM}
                        </Button>
                        :
                        null
                    }
                    {
                        this.props.showAddFirm && this.state.showAddFirm ?
                        <Button style={classes.closeButton} color="secondary" onClick={() => {this.setShowAddFirm(false)}} fullWidth component="div" variant="outlined">
                            {this.props.componentConstants.language.LANG_CANCEL_ADD_FIRM}
                        </Button> 
                        :
                        null
                    }
                    {this.state.showEditFirm ?
                    <AddFirm editFirm={true} element={this.props.element} {...this.buildComponentProps('Appbar')} />
                    :
                    <React.Fragment>
                        {this.props.element ?
                            <Typography>{this.props.element.shopFirmsName} {this.props.element.shopFirmsCif}</Typography>
                            :
                            null
                        }
                    </React.Fragment>
                    }
                    {
                        this.props.showEditFirm && !this.state.showEditFirm ?
                        <Button style={classes.closeButton} color="secondary" onClick={() => {this.setShowEditFirm(true)}} fullWidth component="div" variant="outlined">
                            {this.props.componentConstants.language.LANG_UPDATE_FIRM}
                        </Button>
                        :
                        null
                    }
                    {
                        this.props.showEditFirm && this.state.showEditFirm ?
                        <Button style={classes.closeButton} color="secondary" onClick={() => {this.setShowEditFirm(false)}} fullWidth component="div" variant="outlined">
                            {this.props.componentConstants.language.LANG_CANCEL_EDIT_FIRM}
                        </Button> 
                        :
                        null
                    }
                </div>
    }
}
